function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var _ref2 = /*#__PURE__*/React.createElement("g", {
  clipPath: "url(#clip0_1465_21928)"
}, /*#__PURE__*/React.createElement("path", {
  d: "M11.6136 5.98371L6.63565 10.9616C6.02582 11.5715 5.19871 11.9141 4.33628 11.9141C3.47385 11.9141 2.64674 11.5715 2.0369 10.9616C1.42707 10.3518 1.08447 9.52468 1.08447 8.66225C1.08447 7.79981 1.42707 6.9727 2.0369 6.36287L7.01482 1.38495C7.42138 0.9784 7.97278 0.75 8.54774 0.75C9.12269 0.75 9.6741 0.9784 10.0807 1.38495C10.4872 1.79151 10.7156 2.34292 10.7156 2.91787C10.7156 3.49283 10.4872 4.04423 10.0807 4.45079L5.09732 9.42871C4.89404 9.63198 4.61834 9.74618 4.33086 9.74618C4.04339 9.74618 3.76768 9.63198 3.5644 9.42871C3.36113 9.22543 3.24693 8.94972 3.24693 8.66225C3.24693 8.37477 3.36113 8.09907 3.5644 7.89579L8.16315 3.30245",
  stroke: "#8A8A8A",
  strokeLinecap: "round",
  strokeLinejoin: "round"
}));
var _ref3 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
  id: "clip0_1465_21928"
}, /*#__PURE__*/React.createElement("rect", {
  width: 13,
  height: 13,
  fill: "white"
})));
function SvgPaperclip(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 13,
    height: 13,
    viewBox: "0 0 13 13",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, _ref3);
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPaperclip);
export default __webpack_public_path__ + "static/media/paperclip.073431e8e21c92f43f86c01804a60af6.svg";
export { ForwardRef as ReactComponent };